import { render, staticRenderFns } from "./CalendarWeek.vue?vue&type=template&id=2a4c8d36&"
import script from "./CalendarWeek.vue?vue&type=script&lang=js&"
export * from "./CalendarWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports